import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {AppConstant} from './app/AppConstant'

@Injectable({ providedIn: 'root' })
export class AuthService {
  private loginUrl = AppConstant.baseURL + 'api/auth/login'; // adjust if needed

  constructor(private http: HttpClient) {}

  login(credentials: { maildId: string; otp: string }): Observable<any> {
    return this.http.post(`${this.loginUrl}`, credentials);
  }

  saveToken(token: string): void {
    localStorage.setItem('jwt', token);
  }

  getToken(): string | null {
    return localStorage.getItem('jwt');
  }

  logout(): void {
    localStorage.removeItem('jwt');
    localStorage.removeItem('customerId');
  }
}
